// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2xEG0","label":"Radio_label__w6c6R","checkMark":"Radio_checkMark__2-Baj","disabled":"Radio_disabled__KpA15"};